export default "__VITE_ASSET__DkXBWOaU__"